import { count, eq } from "drizzle-orm";
import { list_organization, organization, type PowerSyncDrizzleDB } from "@listto/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Shared Drizzle query builder for fetching the organization linked to a list.
 */
export function getListOrganizationQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db
    .select({
      organization_id: list_organization.organization_id,
    })
    .from(list_organization)
    .where(eq(list_organization.list_id, listId))
    .limit(1);
}
